import React, { ReactElement } from 'react';

import TopBar from 'components/TopBar';
import { useNavigation } from 'hooks/useNavigation';

import Content from './components/Content';
import { TPageProps } from './Page.types';

function Page({
  hideTopBar = false,
  afterContent,
  children,
  beforeContent,
  contentAutoHeight,
}: TPageProps): ReactElement {
  const {
    goBack,
    isRootPage,
    options: { headerTitle, headerRight },
  } = useNavigation();

  return (
    <>
      {!hideTopBar && (
        <TopBar
          title={headerTitle}
          rightContent={headerRight}
          onActionButtonClick={goBack}
          isRootPage={isRootPage}
        />
      )}
      <Content
        autoHeight={contentAutoHeight}
        beforeContent={beforeContent}
        hasAfterContent={!!afterContent}>
        {children}
      </Content>
      {afterContent}
    </>
  );
}

export default Page;
